import { create, StateCreator } from 'zustand';
import { persist } from 'zustand/middleware';

export interface CustomAttributesUIStoreState {
  // keyed by scope (`side-panel:${surfaceKey}:${sectionKey}`) so multiple
  // hosts don't share collapsed state; value is the list of group keys that
  // are currently collapsed within that scope
  collapsedGroupsByScope: Record<string, string[]>;

  setGroupCollapsed: (scopeKey: string, groupKey: string, collapsed: boolean) => void;
}

const createCustomAttributesUISlice: StateCreator<
  CustomAttributesUIStoreState,
  [],
  [],
  CustomAttributesUIStoreState
> = (set) => ({
  collapsedGroupsByScope: {},

  setGroupCollapsed: (scopeKey, groupKey, collapsed) =>
    set((state) => {
      const current = state.collapsedGroupsByScope[scopeKey] ?? [];
      const isCollapsed = current.includes(groupKey);
      if (collapsed === isCollapsed) return state;
      return {
        collapsedGroupsByScope: {
          ...state.collapsedGroupsByScope,
          [scopeKey]: collapsed
            ? [...current, groupKey]
            : current.filter((k) => k !== groupKey),
        },
      };
    }),
});

const useCustomAttributesUIStore = create<CustomAttributesUIStoreState>()(
  // version bumped to discard the prior `Record<string, boolean>` shape from
  // any pre-release localStorage; no migration needed because this is UI
  // state, not user data.
  persist(createCustomAttributesUISlice, {
    name: 'portal-custom-attributes-ui-store',
    version: 1,
  }),
);

export default useCustomAttributesUIStore;
